<template>
  <div class="toggle-button position-absolute right-0">
    <button
      type="button"
      class="navbar-toggler navbar-toggler-right"
      :class="{ toggled: $sidebar.showSidebar }"
      aria-controls="navigation-index"
      aria-expanded="false"
      aria-label="Toggle navigation"
      @click="toggleSidebar"
    >
      &#9776;
    </button>
  </div>
</template>
<script>
export default {
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    }
  },
  data() {
    return {
      activeNotifications: false
    };
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    }
  }
};
</script>
<style>
.text-align-end {
  text-align: end;
}
.toggle-button {
  display: none;
}

@media screen and (max-width: 990px) {
  .toggle-button {
    display: block;
  }
}

.right-0 {
  right: 0;
}
</style>
